
import * as THREE from 'three';
import { CreateObject } from '../../CreateObject';
import { Point, Line, Draw3d } from '../../graphicLibs/index';
import { PointInfo } from '../../WalltoFittingInfo';
import { CreatePointData } from '../CreatePointData';

/**
 * 開口部判定
 * */
export class OpeningJudge {

    private e: number = 0.01;

    constructor(private pointList: PointInfo[], private branchList: number[], private isVisible: boolean = true) {
        // this.test();
    }

    public execute() {
        const box3 = CreateObject.createBox(this.pointList);
        const size = box3.getSize(new THREE.Vector3());
        // min から時計周りの辺データ
        const boxPointList: THREE.Vector3[] = [   
            box3.min,
            new THREE.Vector3(box3.min.x + size.x, box3.min.y, box3.min.z),
            new THREE.Vector3(box3.min.x + size.x, box3.min.y, box3.min.z + size.z),
            new THREE.Vector3(box3.min.x,          box3.min.y, box3.min.z + size.z)
        ];
        // start, end ...
        let upperSide = [boxPointList[0], boxPointList[1]];
        let rightSide = [boxPointList[1], boxPointList[2]];
        let lowerSide = [boxPointList[2], boxPointList[3]];
        let leftSide = [boxPointList[3], boxPointList[0]];

        // bouding box上の壁を抽出する
        const indexList = [];
        for (let i = 0; i < this.pointList.length; i += 2) {

            const point = this.pointList[i].point;
            const next = this.pointList[Point.nextPoint(i)].point;

            // 壁がe以内のものは計算しない
            if (next.clone().sub(point).length() < this.e) continue;

            // 頂点が乗っているところで壁をカットする
            const cutLine = (res: THREE.Vector3[], line: Line): THREE.Vector3[] => {
                const isOver = line.overLine(point);
                const isOver_ = line.overLine(next);
                // 線分上に存在したらカットする
                if (isOver) res = this.cutLine(res, point);
                if (isOver_) res = this.cutLine(res, next);
                if (isOver && isOver_) indexList.push(i);
                return res;
            }

            // 線分が線分上に存在するか(上辺)
            upperSide = cutLine(upperSide, new Line(this.e, boxPointList[0], boxPointList[1]));
            // 線分が線分上に存在するか(右辺)
            rightSide = cutLine(rightSide, new Line(this.e, boxPointList[1], boxPointList[2]));
            // 線分が線分上に存在するか(下辺)
            lowerSide = cutLine(lowerSide, new Line(this.e, boxPointList[2], boxPointList[3]));
            // // 線分が線分上に存在するか(左辺)
            leftSide = cutLine(leftSide, new Line(this.e, boxPointList[3], boxPointList[0]));
        }

        upperSide = this.moldingX(upperSide);
        rightSide = this.moldingZ(rightSide);
        lowerSide = this.moldingX(lowerSide);
        leftSide = this.moldingZ(leftSide);

        for (let i = 0; i < indexList.length; i++) {
            const index = indexList[i]; 
            const point = this.pointList[index].point;
            const next = this.pointList[Point.nextPoint(index)].point;

            // 重複していない壁を取得(上辺)
            upperSide = this.notDuplicate(upperSide, new Line(this.e, point, next));
            // 重複していない壁を取得(右辺)
            rightSide = this.notDuplicate(rightSide, new Line(this.e, point, next));
            // 重複していない壁を取得(下辺)
            lowerSide = this.notDuplicate(lowerSide, new Line(this.e, point, next));
            // // 重複していない壁を取得(左辺)
            leftSide = this.notDuplicate(leftSide, new Line(this.e, point, next));
        }

        // 描画
        if (this.isVisible) {
            // this.draw(upperSide);
            // this.draw(rightSide);
            // this.draw(lowerSide);
            // this.draw(leftSide);
        }

        const newList = [...this.pointList];
        newList.push(...this.changeForm(upperSide));
        newList.push(...this.changeForm(rightSide));
        newList.push(...this.changeForm(lowerSide));
        newList.push(...this.changeForm(leftSide));
        
        // 外周リスト作成
        const pointData = new CreatePointData(newList);
        pointData.execute();
        const outerWallList = pointData.outerWallList;
        // const outerWallList = new CreateOuterWall(newList).execute();
        // 部屋取得 
        const roomList = pointData.roomList; 
        // const room = new RoomArea(newList, outerWallList);
        // room.execute();
        // 描画
        // room.draw();

        const roomNum = [];
        for (let i = 0; i < roomList.length; i++) {
            const roomIndex = roomList[i];
            let isBranch = false;
            let isExist = true;
            for (let j = 0; j < roomIndex.length; j++) {
                const pointIndex = roomIndex[j];
                if (newList[pointIndex].isExist == false) isExist = false;
                if (this.branchList.includes(pointIndex)) isBranch = true;
            }

            if (isExist) roomNum.push(roomIndex);
            if (isExist == false && isBranch == true) roomNum.push(roomIndex);
        }

        // roomNum.forEach((roomindex: number[]) => {
        //     Draw3d.outerWall(newList, roomindex);
        // });

        return {room: roomNum, point: newList};
    }

    // 
    private changeForm(points: THREE.Vector3[]): PointInfo[] {
        return points.map((point: THREE.Vector3) => new PointInfo(point, false));
    }

    // x方向に形を整える
    private moldingX(sideList: THREE.Vector3[]): THREE.Vector3[] { 
        sideList = this.unique(sideList);
        sideList.sort((a: THREE.Vector3,b: THREE.Vector3) => a.x - b.x);
        return sideList.map((point: THREE.Vector3, index: number, array: THREE.Vector3[]) => {
            if (index == 0 || index == array.length - 1) return point;
            return [point, point];
        }).flat();
    }

    // z方向に形を整える
    private moldingZ(sideList: THREE.Vector3[]): THREE.Vector3[] { 
        sideList = this.unique(sideList);
        sideList.sort((a: THREE.Vector3,b: THREE.Vector3) => a.z - b.z);
        return sideList.map((point: THREE.Vector3, index: number, array: THREE.Vector3[]) => {
            if (index == 0 || index == array.length - 1) return point;
            return [point, point];
        }).flat();
    }

    // Vector3の配列をユニークにして返す
    private unique(array: THREE.Vector3[]) {
        const uniquedArray = [];
        for (const elem of array) {
            if (uniquedArray.find((element: THREE.Vector3) => (element && element.equals(elem))) == undefined) 
                uniquedArray.push(elem);
        }
        return uniquedArray;
    }

    // 重複していない壁を返す
    private notDuplicate(res: THREE.Vector3[], line: Line): THREE.Vector3[] {
        for (let i = 0; i < res.length; i += 2) {
            if (line.overLine(res[i]) && line.overLine(res[i + 1])) {
                res.splice(i, 2);
                break;
            }
        }

        return res;
    }
    
    // 線分を点でカットして返す
    private cutLine (line: THREE.Vector3[], point: THREE.Vector3): THREE.Vector3[] {
        for (let i = 0; i < line.length; i += 2) {
            if (line[i].clone().sub(point).length() < this.e) return line;
            const start = line[i];
            const end = line[Point.nextPoint(i)];
            // 線分上に点が存在したら分割する
            if (new Line(this.e, start, end).overLine(point)) {
                line.push(point);
                break;
            }
        }
        return line;
    }

    // 描画
    private draw(sideLine: THREE.Vector3[]) {
        sideLine.forEach((point: THREE.Vector3, index: number, array: THREE.Vector3[]) => {
            if (index % 2 == 1 || (index == array.length - 1)) return;
            const start = point;
            const end = array[index+1];
            const dir = end.clone().sub(start);
            Draw3d.draw(dir, start);
        });
    }

    private mathLineTest(start: THREE.Vector3, end: THREE.Vector3, point: THREE.Vector3, next: THREE.Vector3): number {
        const isStart = new Line(this.e, start, end).overLine(point); 
        const isEnd = new Line(this.e, start, end).overLine(next);
        // 線分が線上に存在する場合
        if (isStart && isEnd) {
            return 1;
        }
        // 始点が線分上に存在する場合
        if (isStart) {
            return 2;
        }
        // 終点が線分上に存在する場合
        if (isEnd) {
            return 3;
        }

        return 0;
    }

    private test() {
        console.assert(new Line(this.e, new THREE.Vector3(0,0,0), new THREE.Vector3(1,0,0)).overLine(new THREE.Vector3(0.5,0,0)));
        console.assert(new Line(this.e, new THREE.Vector3(0,0,0), new THREE.Vector3(1,0,0)).overLine(new THREE.Vector3(0.5,0,0.001)));
        console.assert(new Line(this.e, new THREE.Vector3(0,0,0), new THREE.Vector3(1,0,0)).overLine(new THREE.Vector3(0.5,0,-0.001)));
        console.assert(new Line(this.e, new THREE.Vector3(0,0,0), new THREE.Vector3(1,0,1)).overLine(new THREE.Vector3(0.5,0,0.5)));

        console.assert(new Line(this.e, new THREE.Vector3(0,0,0), new THREE.Vector3(1,0,0)).overLine(new THREE.Vector3(0.5,0,0.01)) == false);
        console.assert(new Line(this.e, new THREE.Vector3(0,0,0), new THREE.Vector3(1,0,0)).overLine(new THREE.Vector3(-0.5,0,0)) == false);
        console.assert(new Line(this.e, new THREE.Vector3(0,0,0), new THREE.Vector3(1,0,0)).overLine(new THREE.Vector3(1.05,0,0)) == false);

        console.assert(this.cutLine([new THREE.Vector3(0,0,0), new THREE.Vector3(1,0,0)], new THREE.Vector3(0.5,0,0)).length == 4);
        console.assert(this.cutLine([new THREE.Vector3(0,0,0), new THREE.Vector3(1,0,0)], new THREE.Vector3(0.009,0,0)).length == 2);
        console.assert(this.cutLine([new THREE.Vector3(0,0,0), new THREE.Vector3(1,0,0),
                                     new THREE.Vector3(1,0,0), new THREE.Vector3(1,0,1)
                                    ], new THREE.Vector3(0.5,0,0)).length == 6);

        console.assert(this.mathLineTest(new THREE.Vector3(0,0,0), new THREE.Vector3(1,0,0), new THREE.Vector3(0.5,0,0), new THREE.Vector3(0.75,0,0)) == 1);
    }

}